<script>
import payoutsMixin from "@/views/payouts/mixin/payoutsMixin";

export default {
  name: "SourcePayoutsCheckbox",

  mixins: [payoutsMixin],

  data() {
    return {
      isCheckboxChecked: false,
    }
  },

  mounted() {
    this.isCheckboxChecked = this.isPayoutSelected();
  },

  watch: {
    'bulkSourcePayouts'() {
      this.isCheckboxChecked = this.isPayoutSelected();
    },
  },

  props: {
    payout: {
      required: true,
      type: Object
    }
  },

  methods: {
    isPayoutSelected() {
      const { payout_id } = this.payout;
      return this.bulkSourcePayouts.includes(payout_id);
    },
  }
}
</script>

<template>
  <v-checkbox
    @change="selectBulkSourcePayouts($event, payout)"
    dense
    hide-details
    v-model="isCheckboxChecked" />
</template>
